/*********************** Custom JS for Boost AI Search & Discovery  ************************/
if (boostSDAppConfig?.generalSettings) {
   boostSDAppConfig.generalSettings.no_image_url = ' //www.blissboutiques.com/cdn/shop/t/175/assets/placeholder.svg?v=56165349285302004531744132792';
}

/* Boost - 222896 */
function slugify(text) {
	if (text == null || typeof text == 'object') return '';
	if (typeof text != 'string') {
		if (typeof text.toString != 'function') {
			return '';
		} else {
			text = text.toString();
		}
	}
	text = text.toLowerCase();

	// Remove Latin
	var from = "àáäâãèéëêẽìíïîĩòóöôõùúüûũñç·/_,:;";
	var to = "aaaaaeeeeeiiiiiooooouuuuunc--_---";
	for (var i = 0, l = from.length; i < l; i++)
		text = text.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));

	// Remove Czech, Finnish special characters
	var specialCzechChars = 'ÁáÄäČčĎďÉéěÍíŇňÓóÖöŘřŠšŤťÚúůÝýŽž';
	var asciiCzechChars = 'AaAaCcDdEeeIiNnOoOoRrSsTtUuuYyZz';
	var specialCzechCharsLength = specialCzechChars.length;
	for (var j = 0; j < specialCzechCharsLength; j++) {
		text = text.replace(new RegExp(specialCzechChars.charAt(j), "g"), asciiCzechChars.charAt(j));
	}

	// Remove Norway special characters
	var specialNorwayChars = 'ÆæØøÅå';
	var asciiNorwayChars = ['AE', 'ae', 'O', 'o', 'A', 'a'];
	var specialNorwayCharsLength = specialNorwayChars.length;
	for (var k = 0; k < specialNorwayCharsLength; k++) {
		text = text.replace(new RegExp(specialNorwayChars.charAt(k), "g"), asciiNorwayChars[k]);
	}

	// Remove quotes
	text = text.replace(/'/g, '').replace(/"/g, '');

	return text.replace(/[\s\/]+/g, '-')    // Replace spaces with -
		.replace(/[`~!@#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\\/]/g, '-')   // Replace all special characters with -
		.replace(/\-\-+/g, '-')     // Replace multiple - with single -
		.replace(/^-+/, '')         // Trim - from start of text
		.replace(/-+$/, '');         // Trim - from end of text
};
/* Boost - 222896 */

if (window.boostSDAppConfig) {
    window.boostSDAppConfig.integration = Object.assign({
        wishlists: 'plus'
    }, window.boostSDAppConfig.integration || {});
}

var boostSDCustomize = {
    /* Boost - 220333 */
    returnWishlist: (componentRegistry) => {
        componentRegistry.useComponentPlugin("IntegrationProductWishlist", {
            name: "Do something",
            enabled: true,
            apply: () => ({
                props: (props) => {
                    return props;
                },
                afterRender(element) {
                    try {
                        let hasUpdated = false; // Prevent rendering twice
                        const wishlistElm = element.getRootElm();
                        if (wishlistElm && !hasUpdated) {
                            hasUpdated = true;
                            const productImages = document.querySelectorAll(
                                ".boost-sd__product-image"
                            ); // Select boost sd image id
                            productImages.forEach((image) => {
                                if (image.id === wishlistElm.getAttribute("data-product")) {
                                    if (!image.querySelector(".boost-sd__wishlist")) {
                                        image.prepend(wishlistElm);
                                    }
                                }
                            });
                        }
                    } catch(error) {
                        console.warn(error);
                    }
                },
            }),
        });
    },
    /* Boost - 220333 */

    /* Boost - 222896 */
    customLabelByTag: (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductLabel', {
            name: 'Customize label',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    try {
                        if (element.getParams()?.props) {
                            const labelTag = slugify(element.getParams().props.labelText) || '';
                            if (labelTag !== '' && element.getParams().props.labelType == 'customLabelByTag') {
                                const rootElm = element.getRootElm();
                                if (rootElm) {
                                    rootElm.classList.add('boost-sd__product-label-' + labelTag);
                                }
                            }
                        }
                    } catch (error) {
                        console.warn(error);
                        return element; // Fallback -> return the original elm if there is an error
                    }
                },
            }),
        });
    },
    /* Boost - 222896 */


    customLabelByFilter: (componentRegistry) => {
       componentRegistry.useComponentPlugin('FilterOption', {
            name: 'Filter Label',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    try {
                        const urlParams = new URLSearchParams(window.location.search);
                        const param_x = urlParams.getAll('pf_t_type');
                        const titleLength = $('.collection-hero__title .category-type').length;
                
                       var FilterData = '';
                       var length = param_x.length;
                        if(param_x.length > 0){
                          $(param_x).each(function(i, value) {
                              console.log('each',i, value);
                              if ( value != '' ) {
                                  if(i === length-1) {  //The last one
                                      FilterData += ' ' + value;
                                  } else {
                                      FilterData += ' ' + value + ',';
                                  } 
                              }   
                          });
                        }
                      
                        if(FilterData){
                         if(titleLength == 0){
                            $('.collection-hero__title').append('<span class="category-type">: '+FilterData+'</span>');
                          }else{
                            $('.collection-hero__title .category-type').text(':'+FilterData);
                          }
                        }else{
                          $('.collection-hero__title .category-type').remove();	
                        }
                
                    } catch (error) {
                        console.warn(error);
                        return element; // Fallback -> return the original elm if there is an error
                    }
                },
            }),
        });
    },
};


window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    boostSDCustomize.returnWishlist,
    boostSDCustomize.customLabelByTag,
    boostSDCustomize.customLabelByFilter
]);